module.exports = __webpack_public_path__ + "static/media/ManageAccounts – Arabic@2x.a40a16fd.jpg";